import { Option } from "@storeblocks/radio";
import { AdviceProductDetailsFormValues } from "Features/CheckPrice/Products/Advice/ProductDetails/FormElements/interfaces";
import { OneTimePaymentAdvisorChoice } from "Features/CheckPrice/Products/Advice/ProductPrice/AdviceCards/interfaces";
import { getOneTimePaymentText } from "Features/CheckPrice/Products/Advice/ProductPrice/AdviceCards/utils";
import { CoverageNeed } from "Store/akaAdvice/interfaces/CollectiveAdvice";
import {
  AkaGroupLifeCoverage,
  InsuranceCoverage,
} from "Store/interfaces/products/coverage";
import { isDefined } from "Utils/functions";

export const getDisabilityOneTimePaymentAdvisorChoiceOptions = (
  need: CoverageNeed,
  adviceDetails: AdviceProductDetailsFormValues,
  oneTimePaymentValue: number,
  oneTimePayment: any,
  lang: string,
): Option[] => {
  return [
    ...(oneTimePaymentValue > 0
      ? [
          {
            label: getOneTimePaymentText(
              need,
              adviceDetails,
              oneTimePaymentValue,
              oneTimePayment,
              lang,
            ),
            value: OneTimePaymentAdvisorChoice.ADVICED_ONE_TIME_PAYMENT,
            id: `disabilityOneTimePaymentAdvisorChoice-${OneTimePaymentAdvisorChoice.ADVICED_ONE_TIME_PAYMENT}`,
          },
        ]
      : []),
    {
      label: oneTimePayment.advisorTexts.customOneTimePaymentAdvisor[lang],
      value: OneTimePaymentAdvisorChoice.CUSTOM_ONE_TIME_PAYMENT,
      id: `disabilityOneTimePaymentAdvisorChoice-${OneTimePaymentAdvisorChoice.CUSTOM_ONE_TIME_PAYMENT}`,
    },
    {
      label: oneTimePayment.advisorTexts.noOneTimePaymentAdvisor[lang],
      value: OneTimePaymentAdvisorChoice.NO_ONE_TIME_PAYMENT,
      id: `disabilityOneTimePaymentAdvisorChoice-${OneTimePaymentAdvisorChoice.NO_ONE_TIME_PAYMENT}`,
    },
  ];
};

export const isAkaGroupLifeTimeCoverage = (
  coverage?: InsuranceCoverage,
): boolean =>
  isDefined(coverage) &&
  coverage === AkaGroupLifeCoverage.AKA_GROUP_LIFE_INCAP_AND_TIME;
